import { render, staticRenderFns } from "./td.vue?vue&type=template&id=f5d6645e&"
import script from "./td.vue?vue&type=script&lang=js&"
export * from "./td.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports